import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Navbar from '../layout/Navbar';
import { decryptData } from '../../utils/encrypt';
import { ACCOUNT_DETAILS_ENDPOINT } from '../../config/api';

function AccountView() {
  const { id, token } = useParams();
  const navigate = useNavigate();

  const [account, setAccount] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchAccount = async () => {
      try {
        const encryptedUser = localStorage.getItem('suyog_user');
        if (!encryptedUser) {
          setError('User not authenticated');
          return;
        }

        const { user_id, user_token } = decryptData(encryptedUser);

        const res = await fetch(ACCOUNT_DETAILS_ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id, account_token: token, user_id, user_token }),
        });

        const data = await res.json();

        if (res.ok && data.account) {
          setAccount(data.account);
        } else {
          setError(data.error || 'Failed to load account');
        }
      } catch (err) {
        console.error('Fetch error:', err);
        setError('Server error');
      } finally {
        setLoading(false);
      }
    };

    fetchAccount();
  }, [id, token]);

  if (loading) return <div className="container mt-4">Loading...</div>;
  if (error) return <div className="container mt-4 text-danger">{error}</div>;

  return (
    <>
      <Navbar />
      <div className="container mt-4">
        <div className="card p-4 shadow-sm">
          <h4 className="mb-3">Account Details</h4>
          <p><strong>Name:</strong> {account.account_name}</p>
          <p><strong>City:</strong> {account.city}</p>
          <p><strong>State:</strong> {account.state}</p>
          <p><strong>Address:</strong> {account.address}</p>
          <p><strong>Pincode:</strong> {account.pincode}</p>
          <p><strong>Mobile:</strong> {account.mobile}</p>
          <p><strong>Email:</strong> {account.email}</p>
          <p><strong>Created By:</strong> {account.created_by_name || 'N/A'}</p>
          <p><strong>Updated By:</strong> {account.updated_by_name || 'N/A'}</p>
          <button className="btn btn-secondary mt-3" onClick={() => navigate(-1)}>
            Back
          </button>
        </div>
      </div>
    </>
  );
}

export default AccountView;
